import Vue from 'vue'
import store from '@/store'
import tz, { bindAccountTimeZoneReader } from '@/utils/timezone'

/**
 * 全局时区工具：Vue.prototype.$tz
 * 约定：API 响应时间已按账号 IANA 时区偏移，展示用 displayDateTime；查询用 browserLocalToAccountString。
 */
bindAccountTimeZoneReader(() => store.getters.accountTimeZone)
Vue.prototype.$tz = tz
Vue.filter('tzDisplay', tz.displayDateTime)
